<template>
  <div>
    <div>
      <v-toolbar
        flat
        color="white"
      >
        <v-spacer />
        <div>
          <v-btn
            color="success"
            text
          >
            {{ `Итоги балансов:` }}
          </v-btn>

          <v-btn
            color="success"
            rounded
            outlined
          >
            {{ `${getTotalAmount} ₽` }}
          </v-btn>
        </div>
        <div>
          <v-btn
            color="secondary"
            text
          >
            {{ `Итоги по офферам:` }}
          </v-btn>

          <v-btn
            color="secondary"
            rounded
            outlined
          >
            {{ `${getTotalOffers}` }}
          </v-btn>
        </div>
        <v-spacer />
      </v-toolbar>
      <v-card>
        <v-card-text>
          <WBDOfficeListFilter
            :office-list-filter-set.sync="officeListFilterSet"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            v-if="getActiveFilterNumber > 0"
            class="mr-1"
            text
            color="warning"
            @click="resetFilterSet"
          >
            {{ `Очистить` }}
          </v-btn>
          <v-btn
            rounded
            color="success"
            @click="requestData(options.page, options.itemsPerPage)"
          >
            Поиск
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :headers="headers"
      :items="getList"
      :options.sync="options"
      :loading="loading"
      :server-items-length="getPaginator.total"
      :footer-props="footerProps"
      class="elevation-1"
    >
      <template v-slot:item.supportNumber="{ item }">
        <ItemLinkView
          :label="undefined"
          :value="getOfficeViewHref(item)"
          :link-text="`${item.supportNumber || ' '}`"
        />
      </template>
      <template v-slot:item.externalCode="{ item }">
        <span>{{ item.externalCode }}</span>
        <span v-if="item.storeId"> / {{ item.storeId }}</span>
      </template>
      <template v-slot:item.isActive="{ item }">
        <v-btn
          text
          icon
          :color="item.status === 'active' ? 'success' : 'error'"
        >
          <v-icon>{{ item.status === 'active' ? 'check' : 'close' }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.hasShiftStarterProviderLevel="{ item }">
        <v-btn
          text
          icon
          :color="!!item.hasShiftStarterProviderLevel ? 'success' : 'error'"
        >
          <v-icon>{{ !!item.hasShiftStarterProviderLevel ? 'check' : 'close' }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.transportation="{ item }">
        <v-btn
          text
          icon
          :color="item.transportation && item.transportation.id ? 'success' : 'error'"
        >
          <v-icon>{{ item.transportation && item.transportation.id ? 'check' : 'close' }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.rawRegion="{ item }">
        <span v-if="item.rawRegion">
          <span v-if="item.rawRegion && item.rawRegion.code"> {{ ` [${item.rawRegion.code}]` }}</span>
          {{ item.rawRegion.title }}
        </span>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn
          text
          outlined
          rounded
          small
          @click="gotoOfficeView(item)"
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { OFFICE_VIEW_ROUTE_NAME } from '@/router/client'
import ListMixin from '@/mixins/list-mixin.vue'
import WBDOfficeListFilter from '@/components/common/filter/office-list-filter'
import OfficeListUtil from '@/utils/office-list-filter-util'

export default {
  name: 'WBDOfficeListPage',
  components: { WBDOfficeListFilter },
  mixins: [ListMixin],
  data: () => ({
    searchQuery: '',
    loading: true,
    officeListFilterSet: {
      organization: undefined,
      city: undefined,
      shiftProviderLevel: undefined,
      region: undefined,
      status: undefined,
      type: undefined,
      searchQuery: '',
    },
    options: {},
    headers: [],
  }),
  computed: {
    getActiveFilterNumber () {
      return OfficeListUtil.getActiveFilterNumber(this.officeListFilterSet)
    },
    getList () {
      return this.$store.getters['office/getStoreList']
    },
    getTotalAmount () {
      if (!this.getStats || !this.getStats.totalAmount) {
        return 0
      }

      return new Intl.NumberFormat().format(this.getStats.totalAmount)
    },
    getTotalOffers () {
      if (!this.getStats || !this.getStats.totalOffer) {
        return 0
      }

      return new Intl.NumberFormat().format(this.getStats.totalOffer)
    },
    getPaginator () {
      return this.$store.getters['office/getPaginator']
    },
    getStats () {
      return this.$store.getters['office/getStats']
    }
  },
  watch: {
    options: {
      handler () {
        this.requestData(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
    searchQuery (val) {
      val || this.requestData(this.options.page, this.options.itemsPerPage)
    },
  },
  created () {
    this.headers = OfficeListUtil.officeListHeader
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[1],
    }
  },
  methods: {
    async resetFilterSet () {
      this.officeListFilterSet = {
        organization: undefined,
        region: undefined,
        city: undefined,
        status: undefined,
        type: undefined,
        searchQuery: '',
      }

      this.$forceUpdate()

      this.eventsBus.$emit(this.eventNames.OFFICE_LIST_FILTER_RESET)

      // this.requestData()
    },
    async requestData (page = 1, size = 250, resetQuery) {
      if (resetQuery) {
        this.officeListFilterSet.searchQuery = null
      }

      let params = { 'page[number]': page, 'page[size]': size }
      params = {
        ...params,
        ...OfficeListUtil.getOfficeListParamsFromFilter(this.officeListFilterSet)
      }

      await this.$store.dispatch(
        'office/getModelList',
        { params }

      )
      this.loading = false
    },
    gotoOfficeView (item) {
      const routeData = this.$router.resolve(
        { name: OFFICE_VIEW_ROUTE_NAME, params: { id: item.id } }
      )
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
  .office-item {
    cursor: pointer;
  }
</style>
